export default __webpack_public_path__ + "static/media/mobile-phone-top.1b9e0858.png";